import React, { useCallback, useEffect, useState } from "react";
import "./FormalitesNoticeModal.css";

const FORMALITES_NOTICE_KEY = "formalitesNoticeModal";
const FORMALITES_NOTICE_CURRENT_KEY = `${FORMALITES_NOTICE_KEY}_study_logo`;

function ExternalLinkIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="formalites-notice-link-icon">
      <rect x="4" y="4" width="16" height="16" rx="3" stroke="currentColor" strokeWidth="1.4" />
      <path d="M10 14l5-5M11 9h4v4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function ChevronRightIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="formalites-notice-chevron">
      <path d="M9 5l7 7-7 7" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function FormalitesNoticeModal() {
  const [showModal, setShowModal] = useState(
    () => localStorage.getItem(FORMALITES_NOTICE_CURRENT_KEY) !== "true"
  );

  const closeModal = useCallback(() => {
    localStorage.setItem(FORMALITES_NOTICE_CURRENT_KEY, "true");

    setShowModal(false);
  }, []);

  useEffect(() => {
    if (!showModal) {
      return undefined;
    }

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        closeModal();
      }
    };

    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [closeModal, showModal]);

  if (!showModal) {
    return null;
  }

  return (
    <div
      className="formalites-notice-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="formalites-notice-title"
      onClick={closeModal}
    >
      <div className="formalites-notice" onClick={(event) => event.stopPropagation()}>
        <div className="formalites-notice-side-bar" />
        <button type="button" className="formalites-notice-close-button" aria-label="Fermer" onClick={closeModal}>
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 40 40"
            xmlSpace="preserve"
            className="formalites-notice-close"
          >
            <circle fill="#0a354f" stroke="#ffffff" strokeWidth="1" strokeMiterlimit="8" cx="20" cy="20" r="19" />
            <g>
              <g>
                <g>
                  <path
                    fill="#ffffff"
                    d="M8.21,9.97c6.37,6.37,12.73,12.73,19.1,19.1c0.91,0.91,1.81,1.81,2.72,2.72c1.14,1.14,2.91-0.63,1.77-1.77
                    c-6.37-6.37-12.73-12.73-19.1-19.1c-0.91-0.91-1.81-1.81-2.72-2.72C8.84,7.07,7.07,8.83,8.21,9.97L8.21,9.97z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    fill="#ffffff"
                    d="M9.97,31.8c6.37-6.37,12.73-12.73,19.1-19.1c0.91-0.91,1.81-1.81,2.72-2.72c1.14-1.14-0.63-2.91-1.77-1.77
                    c-6.37,6.37-12.73,12.73-19.1,19.1c-0.91,0.91-1.81,1.81-2.72,2.72C7.07,31.17,8.83,32.93,9.97,31.8L9.97,31.8z"
                  />
                </g>
              </g>
            </g>
          </svg>
        </button>
        <div className="formalites-notice-content">
          <p className="formalites-notice-kicker">Solution Digitale Éditions Langloÿs</p>
          <div className="formalites-notice-body">
            <h2 id="formalites-notice-title">NOUVEAU !</h2>
            <div className="formalites-notice-list">
              <p>
                Vous pouvez désormais intégrer <strong>le logo de votre étude</strong> directement sur tous vos documents de synthèse téléchargeables !
              </p>
              <p>
                <em>Un moyen simple de renforcer votre image et de vous distinguer auprès de vos clients.</em>
              </p>
            </div>
            <div className="formalites-notice-highlight">
              <div className="formalites-notice-links">
                <a
                  href="mailto:support@langloys.com"
                  className="formalites-notice-link"
                  onClick={closeModal}
                >
                  <ExternalLinkIcon />
                  <strong>Cliquez ici pour nous transmettre votre logo</strong>
                  <ChevronRightIcon />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FormalitesNoticeModal;
